import AvatarThreeRow from "./avatar-three-row";

export default AvatarThreeRow;